import React from "react";
import {
  useCouponPromotionCodes,
  useCtxReferences,
  useProductsPrices,
  useTaxRates
} from "utils/selectors";
import { prepareShortLinkList } from "utils/shortLink";
import PaymentLinkCard from "components/PaymentLinkCard";

const ProductPaymentLinksIndex = ({ paymentLinks }) => {
  const { application } = useCtxReferences();
  const { prices, products } = useProductsPrices();
  const { coupons } = useCouponPromotionCodes();
  const taxRates = useTaxRates();

  const preparedPaymentLinks = prepareShortLinkList({
    shortLinks: paymentLinks,
    subdomain: application.subdomain,
    alias: application.alias,
    prices,
    products,
    coupons,
    taxRates,
    shouldOrder: true
  });

  const nodes = preparedPaymentLinks.map((paymentLink, linkIx) => (
    <li className={linkIx ? "pt3" : ""} key={paymentLink.id}>
      <PaymentLinkCard
        uuid={paymentLink.uuid}
        title={paymentLink.title}
        formattedValue={paymentLink.formattedValue}
        shortId={paymentLink.shortId}
        previewUrl={paymentLink.previewUrl}
        createdAt={paymentLink.createdAt}
      />
    </li>
  ));

  return <ul className="w-100 ma0 pa0 list">{nodes}</ul>;
};

export default ProductPaymentLinksIndex;
